import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/ekram/Documents/GitHub/olmo-landing-page/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/ekram/Documents/GitHub/olmo-landing-page/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/ekram/Documents/GitHub/olmo-landing-page/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ekram/Documents/GitHub/olmo-landing-page/src/components/common/MobileNavbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ekram/Documents/GitHub/olmo-landing-page/src/components/common/Navbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ekram/Documents/GitHub/olmo-landing-page/src/components/home/home/app-screens/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ekram/Documents/GitHub/olmo-landing-page/src/components/home/home/testimonial/Testimonials.js");
